"use strict";
exports.__esModule = true;
var fp = typeof window !== "undefined" && window.flatpickr !== undefined
    ? window.flatpickr
    : {
        l10ns: {}
    };
exports.Persian = {
    weekdays: {
        shorthand: ["یک", "دو", "سه", "چهار", "پنج", "آدینه", "شنبه"],
        longhand: [
            "یک‌شنبه",
            "دوشنبه",
            "سه‌شنبه",
            "چهارشنبه",
            "پنچ‌شنبه",
            "آدینه",
            "شنبه",
        ]
    },
    months: {
        shorthand: [
            "ژانویه",
            "فوریه",
            "مارس",
            "آوریل",
            "مه",
            "ژوئن",
            "ژوئیه",
            "اوت",
            "سپتامبر",
            "اکتبر",
            "نوامبر",
            "دسامبر",
        ],
        longhand: [
            "ژانویه",
            "فوریه",
            "مارس",
            "آوریل",
            "مه",
            "ژوئن",
            "ژوئیه",
            "اوت",
            "سپتامبر",
            "اکتبر",
            "نوامبر",
            "دسامبر",
        ]
    },
    ordinal: function () {
        return "";
    }
};
fp.l10ns.fa = exports.Persian;
exports["default"] = fp.l10ns;



//////////////////
// WEBPACK FOOTER
// ./~/flatpickr/dist/l10n/fa.js
// module id = 272
// module chunks = 0